import { createGlobalStyle } from 'styled-components';
import { Content, Header, Title } from '@spa/shared/components/Modal/styles';
export var GlobalModalStyle = /*#__PURE__*/createGlobalStyle([".payment-summary{", "{> svg.close-icon{margin-right:", ";}}", "{margin:0;}", "{padding:", ";}}"], Header, function (props) {
  return props.theme.space(-2);
}, Title, Content, function (props) {
  return props.theme.space(4);
});